
import { defineComponent, reactive, onBeforeMount, computed } from 'vue'

// @components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// @module components
import TimeSlotByDayItem from '@/modules/TimeSlotsModule/components/TimeSlotByDay/index.vue'
import TimeSlotChangeStatusModal from '@/modules/TimeSlotsModule/components/TimeSlotChangeStatusModal/index.vue'

// @types
import type { DispatcherSector } from '@/new-services/types/dispatcher-sectors'
import type { TimeSlotByDay } from '@/new-services/types/time-slots'

// @new-services
import dispatcherSectorsAPI from '@/new-services/dispatcher-sectors.service'
import timeSlotsAPI from '@/new-services/time-slots.service'

// @composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        PageTitle,
        TheButton,
        Loader,
        TheInput,
        TheSelect,
        TimeSlotByDayItem,
        TimeSlotChangeStatusModal
    },
    setup() {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            items: [] as TimeSlotByDay[]
        })

        const filters_state = reactive({
            date: undefined as string | undefined,
            dispatcherSectorId: null as number | null,
            typeId: 2
        })

        const change_status_state = reactive({
            is_opened: false,
            timeSlotId: null as number | null,
            statusId: null as number | null
        })

        const data_state = reactive({
            dispatcher_sectors: {
                is_loading: false,
                is_failed: false,
                list: [] as DispatcherSector[]
            }
        })

        const loadDispatcherSectors = async () => {
            try {
                data_state.dispatcher_sectors.is_loading = true

                const response = await dispatcherSectorsAPI.getDispatcherSectors({ page: 1, limit: 9999 })
                data_state.dispatcher_sectors.list = response.data.data

                data_state.dispatcher_sectors.is_failed = false
            } catch (error) {
                data_state.dispatcher_sectors.is_failed = true
                console.error(error)
                notifications.notifyError({ error, title: 'При получении секторов диспетчера произошла ошибка' })
            } finally {
                data_state.dispatcher_sectors.is_loading = false
            }
        }

        const loadTimeSlotsByDay = async () => {
            if (!filters_state.date || !filters_state.dispatcherSectorId) return

            if (filters_state.date) {
                if (new Date(filters_state.date).getFullYear() < new Date(Date.now()).getFullYear() - 2) {
                    return
                }
            }

            state.items = []

            try {
                state.is_loading = true

                const response = await timeSlotsAPI.getTimeSlotsByDay({
                    date: filters_state.date,
                    dispatcherSectorId: filters_state.dispatcherSectorId,
                    typeId: filters_state.typeId,
                })

                state.items = response.data.data

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
                notifications.notifyError({ error, title: 'При получении тайм-слотов произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        onBeforeMount(() => {
            const date = new Date(Date.now())
            filters_state.date = date.toISOString().split('T')[0]
            loadDispatcherSectors()
        })

        const onChangeTimeSlotStatus = (payload: { timeSlotId: number; statusId: number }) => {
            change_status_state.statusId = payload.statusId
            change_status_state.timeSlotId = payload.timeSlotId
            change_status_state.is_opened = true
        }

        const onCancelChangeTimeSlotStatus = () => {
            change_status_state.is_opened = false
            change_status_state.statusId = null
            change_status_state.timeSlotId = null
        }

        const onTimeSlotStatusChanged = () => {
            onCancelChangeTimeSlotStatus()
            loadTimeSlotsByDay()
        }


        return {
            state,
            filters_state,
            change_status_state,
            data_state,
            loadDispatcherSectors,
            loadTimeSlotsByDay,
            onChangeTimeSlotStatus,
            onCancelChangeTimeSlotStatus,
            onTimeSlotStatusChanged,
        }
    }
})
